import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faLineChart, faThumbsUp, faComment, faRetweet, faMousePointer, faUsers
} from '@fortawesome/free-solid-svg-icons';

import "../../styles/analytics/top-posts.scss";
import { enrichPost, parsePostText } from "../../utils/analytics-utils";
import PlatformIcon from "../common/platform-icon.jsx";
import DOMPurify from 'dompurify';

const openWindow = (link) => {
    if (link !== undefined && link.length !== 0) {
        window.open(link);
    }
};

const TopPosts = ({ topPosts, isPdf = false }) => {
    const posts = topPosts && Array.isArray(topPosts.posts) ? [...topPosts.posts] : [];
    
    if (posts && posts.length) {
        posts.sort((a, b) => ((a.weightedEngagement > b.weightedEngagement) ? -1 : 1));
        posts.every(a => enrichPost(a));
    }

    return (
        <div className="top-posts container" style={{ width: "95%" }}>
            <div className="row">
                {
                    (!posts || posts.length === 0) ? (
                        <div className="col">
                            <p className="no-top-posts">
                                No top posts to show for selected date range.
                            </p>
                        </div>
                    ) : (
                    posts.map((post, index) => (
                        <div key={index} className="col col-sm-4 col-md-4"
                             style={{ verticalAlign: "top" }}>
                            <div
                                className="content-holder subtle-font top-posts-container">
                                {
                                    index === 0 && (
                                        <p className="top-post-banner">
                                            <FontAwesomeIcon icon={faLineChart}
                                                             style={{ marginRight: "5px" }} />
                                            Top Post
                                        </p>)
                                }
                                <div>
                                    <div className="post-basic-info-container">
                                        <div className="platform-icon">
                                            <PlatformIcon
                                                platform={{ "type": post.platformType }}
                                                classes={`profile-pic-platform-icon ${post.platformType.toLowerCase()}`}></PlatformIcon>

                                            <div
                                                className="profile-pic clickable"
                                                onClick={() => openWindow(post.pageUrl)}>
                                                <img width="50px"
                                                     height="50px"
                                                     src={post.profilePicUrl}
                                                     style={{ borderRadius: "50%" }} />
                                            </div>
                                        </div>
                                        <div
                                            className="post-basic-info">
                                            <span
                                                className="post-name">{post.name}</span>
                                            <span
                                                className="post-username ">{post.username}</span>
                                            <br />
                                            <a className="simple-link post-date"
                                               href={post.postUrl}
                                               target="_blank">{post.date}</a>
                                        </div>
                                    </div>
                                </div>

                                <div className="post-text">
                                    <span className="ng-binding"
                                          style={{ whiteSpace: "pre-wrap" }}
                                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parsePostText(post)) }} />
                                </div>
                                {
                                    post.mediaUrl != null && !post.hasVideo && !post.websiteMeta && (
                                        <div style={{ position: "relative" }}>
                                            <img className="post-media"
                                                 src={post.mediaUrl} />
                                        </div>)
                                }
                                {
                                    post.hasVideo && isPdf && post.mediaUrl && (
                                        <div style={{ position: "relative" }}>
                                            <img className="post-media"
                                                 src={post.mediaUrl} />
                                        </div>)
                                }
                                {
                                    post.hasVideo && !isPdf && post.platformType === 'LINKEDIN' && (
                                        <div>
                                            <a href={post.postUrl}
                                               target="_blank">
                                                <video src={post.videoUrl}
                                                       poster={post.mediaUrl}
                                                       className="video-poster"
                                                       controls></video>
                                                <span
                                                    className="overlay-center">Video is not available.  Click to view post natively on LinkedIn.</span>
                                            </a>
                                        </div>)
                                }
                                {
                                    post.hasVideo && !isPdf && post.platformType !== 'LINKEDIN' && (
                                        <video src={post.videoUrl}
                                               poster={post.mediaUrl}
                                               className="video-poster"
                                               controls></video>)}
                                {
                                    post.websiteMeta && !post.hasVideo && (
                                    <div>
                                        <img
                                            className="website-metadata-image"
                                            src={post.websiteMeta.image}
                                        />
                                        <div
                                            className="content-link-description">
                                            <div
                                                className="website-metadata-title"> {post.websiteMeta.title} </div>
                                            <div
                                                className="website-metadata-description"> {post.websiteMeta.description} </div>
                                            <span className="tooltip-parent"
                                                  style={{ paddingBottom: "10px", paddingLeft: "10px" }}>
                                                <span
                                                    className="website-metadata-domain"> {post.websiteMeta.domain} </span>
                                                <a className="tooltip-overlay website-metadata-url"
                                                   target="_blank"
                                                   href={post.websiteMeta.url}> {post.websiteMeta.url} </a>
                                            </span>
                                        </div>
                                    </div>
                                    )
                                }
                                <table
                                    className="padded-table post-metrics-container">
                                    <tbody>
                                    <tr>
                                        <td>
                                            <FontAwesomeIcon
                                                icon={faThumbsUp}
                                                className="post-metric"
                                                style={{ marginRight: "5px" }} />
                                            <span> {post.numLikesFormatted} </span>
                                        </td>
                                        <td>
                                            <FontAwesomeIcon
                                                icon={faComment}
                                                className="post-metric"
                                                style={{ marginRight: "5px" }} />
                                            <span> {post.numCommentsFormatted} </span>
                                        </td>
                                        <td>
                                            <FontAwesomeIcon
                                                icon={faRetweet}
                                                className="post-metric"
                                                style={{ marginRight: "5px" }} />
                                            <span> {post.numSharesFormatted} </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FontAwesomeIcon
                                                icon={faMousePointer}
                                                className="post-metric"
                                                style={{ marginRight: "5px" }} />
                                            <span> {post.numClicksFormatted} </span>
                                        </td>
                                        <td>
                                            <FontAwesomeIcon icon={faUsers}
                                                             className="post-metric"
                                                             style={{ marginRight: "5px" }} />
                                            <span> {post.numImpressionsFormatted} </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>)
                    ))
                }
            </div>
        </div>);
}

export default TopPosts;